import React from "react";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { replaceImageURL } from "../../../common/Navigation";


class BottomAdvBanner extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      updates: false
    }
  }


  settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  render() {
    let bottomImages = this.props.bottomImages;
    let innerPage = this.props.innerPage;
    // 

    return (
      <Slider {...this.settings}>
        {/* Slider 1 */}
        {bottomImages.length && bottomImages.map(banner => (
          <div>
            <div className={`shopOfferBanner retail landingPageAddBanner ${innerPage && 'innerPage'}`} style={{ display: `block` }}>
              <div className='addContainer'>
                <div className='shopOfferBanner-wrap' style={{ backgroundColor: banner.background_color }}>
                  <div className='offerContent' style={{ color: banner.font_color }}>
                    <span>{banner.sub_title}</span>
                    <h3>{banner.title}</h3>
                    <p>{banner.description}</p>
                    <Link className='btn-border' to={banner.image_url} title={banner.url_title} style={{ borderColor: banner.font_color, color: banner.font_color }}>
                      {banner.url_title}
                    </Link>
                  </div>
                  <div className='offerImg' style={{ backgroundImage: `url(${replaceImageURL(banner.image, 650, 420)})` }}></div>
                </div>
              </div>
            </div>
          </div>))}
      </Slider>
    )
  }
};

export default BottomAdvBanner;
